<template>
  <div class="vulnerabilities-page">
    <navigation-bar title="Vulnerabilities" @logout="logout" />
    <h1>Vulnerabilities Page</h1>
    <div class="content">
      <div class="content-grid">
        <div class="subcategory-section">
          <h2 class="section-title">Momentane CVEs</h2>
          <div class="articles-row" id="current-cves">
            <ArticleCard v-for="article in currentCVEs"
                        :key="article.id"
                        :article="article"
                        @click="openLink(article.url)" />
          </div>
        </div>
        
        <div class="subcategory-section">
          <h2 class="section-title">PoC zu CVEs</h2>
          <div class="articles-row" id="poc-cves">
            <ArticleCard v-for="article in pocCVEs"
                        :key="article.id"
                        :article="article"
                        @click="openLink(article.url)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from '../components/Navigation.vue'
import ArticleCardComponent from '../components/ArticleCard.vue'

export default {
  name: 'VulnerabilitiesView',
  components: {
    NavigationBar,
    ArticleCard: ArticleCardComponent
  },
  data() {
    return {
      currentCVEs: [],
      pocCVEs: []
    }
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    },
    logout() {
      // Implement logout logic
    }
  },
  mounted() {
    // Fetch CVEs data here
  }
}
</script>

<style scoped>
.vulnerabilities-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;
  background-color: #1a1a2e;
  color: white;
  min-height: 100vh;
}

.content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.content-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.subcategory-section {
  background-color: #16213e;
  padding: 20px;
  border-radius: 8px;
}

.articles-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.article-card {
  background-color: #0f3460;
  padding: 20px;
  border-radius: 8px;
  flex: 1 1 calc(33.333% - 20px);
  box-sizing: border-box;
}

.section-title {
  margin-bottom: 10px;
  font-size: 1.5rem;
  color: #e94560;
}
</style>